import { idGenerator } from '@/services'

export interface EMobilityConnectionState {
  requestId: string
}

export const InitialState: EMobilityConnectionState = {
  requestId: idGenerator.getNewWebReference()
}
